export default __webpack_public_path__ + "static/media/eventTable.31f9bc88.jpg";